export default __webpack_public_path__ + "static/media/spin-hover.343bc6e7.svg";